import { theme } from 'pro/config/theme';
import { isPhone } from 'base/utils/client';

export type SizeType = number | string | (() => number | string);

function getNumber(str: string) {
    return Number(str.replace(/[^0-9.*]/g, ''));
}

function transRem(attr: string) {
    let value;
    if (attr.includes('rem')) {
        const remValue = getNumber(attr);
        let tagHtml = document.getElementsByTagName('html')[0];
        let htmlFontSize = getNumber(tagHtml.style.fontSize);
        value = remValue * htmlFontSize;
    } else {
        value = getNumber(attr);
    }
    return value;
}

export function getPxSize(param: SizeType, defaultSize: number, scopeSize?: number): number {
    let size: number;
    if (typeof param === 'function') {
        param = param();
    }
    if (typeof param === 'number') {
        size = param;
    } else if (param.endsWith('%') && scopeSize) {
        // 百分比
        const percent = parseFloat(param.replace('%', '')) / 100;
        size = scopeSize * percent;
    } else if (param.endsWith('px') || param.endsWith('rem')) {
        size = transRem(param);
    } else {
        size = defaultSize;
    }
    return Math.floor(size);
}

export function get750RemValue(pxValue: number): string {
    return `${Math.round((pxValue / 24) * 1000) / 1000}rem`;
}

export function get375RemValue(pxValue: number): string {
    return `${Math.round((pxValue / 12) * 1000) / 1000}rem`;
}

export function get375CssValue(pxValue: number): string {
    if (pxValue === 0) {
        return '0px';
    }
    if (typeof pxValue === 'number') {
        return isPhone && theme.useRem
            ? `${Math.round((pxValue / 12) * 1000) / 1000}rem`
            : `${pxValue}px`;
    }
    return pxValue;
}


export function getPlaceholderPercentage(width: number, height: number) {
    return (Math.round((height / width) * 100000) / 1000) + '%';
}

export function getPercentage(numerator: number, denominator: number): string {
    return (Math.round((numerator / denominator) * 100000) / 1000) + '%';
}